/**
 * PATH: packages/email-hub/src/feature/components/IntelligenceWorkspace.tsx
 * FILE_ID: EMAILHUB-COMPONENT-INTEL-WORKSPACE-001
 * PURPOSE: Phase C C-04 — replace legacy AIEmailPanel surface composition.
 * WHY: One workspace mounts analysis + copilot; consumers stop importing
 *      AIEmailPanel directly.
 */
import IntelligenceAnalysis from './IntelligenceAnalysis'
import AIEmailCopilot from './AIEmailCopilot'
import type { RuleRequestApiSlice } from './RequestRuleDialog'
import type { Email } from '../hooks/useEmails'

export interface IntelligenceWorkspaceProps {
  email: Email
  compact?: boolean
  autoAnalyze?: boolean
  onActionClick?: (action: string, payload?: Record<string, unknown>) => void
  /** When org + api provided, mount conversational rule copilot. */
  api?: RuleRequestApiSlice
  orgId?: number | null
  copilotSeed?: string
  copilotSeedNonce?: number
  onApplied?: () => void
}

export default function IntelligenceWorkspace({
  email,
  compact = false,
  autoAnalyze = false,
  onActionClick,
  api,
  orgId,
  copilotSeed,
  copilotSeedNonce,
  onApplied,
}: IntelligenceWorkspaceProps) {
  const showCopilot =
    api != null &&
    orgId != null &&
    (typeof api.proposeRuleRequest === 'function' ||
      typeof api.proposeRuleRequestStream === 'function') &&
    typeof api.applyRuleRequest === 'function'

  return (
    <div data-testid="intelligence-workspace" className="space-y-3">
      <IntelligenceAnalysis
        email={email}
        compact={compact}
        autoAnalyze={autoAnalyze}
        onActionClick={onActionClick}
      />
      {showCopilot && (
        <AIEmailCopilot
          api={api}
          orgId={orgId}
          emailId={email.id}
          senderAddress={email.from_address}
          category={email.category}
          seed={copilotSeed}
          seedNonce={copilotSeedNonce}
          onApplied={onApplied}
        />
      )}
    </div>
  )
}
